import { render } from "./PageNotFoundComponent.vue?vue&type=template&id=4683348e&scoped=true"
import script from "./PageNotFoundComponent.vue?vue&type=script&lang=js"
export * from "./PageNotFoundComponent.vue?vue&type=script&lang=js"

import "./PageNotFoundComponent.vue?vue&type=style&index=0&id=4683348e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4683348e"]])

export default __exports__